export default __webpack_public_path__ + "static/media/illustration-login.df911617.svg";